import classNames from 'classnames';
import '../alert.scss';
import './AlertError.scss';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    message: string;
    link?: string;
    linkClick?: () => void;
};

const AlertError = ({ className, message, linkClick, link, ...rest }: Props) => (
    <div {...rest} className={classNames('app-alert app-alert-error', { [className]: !!className })}>
        <p>{message}</p>
        {link && linkClick ? <div onClick={linkClick} className='aae-link'>{link}</div> : null}
    </div>
);

export default AlertError;
